import {
  FoxLogo,
  RenderbusLogo,
  ServiceActivedIcon,
  ServiceFoxActivedIcon,
} from 'task-eva-ui/assets/icons'
import {
  HeaderWrapper,
  LogoWrap,
  HeaderItem,
  OrangeRadio,
  HeaderItemGapLine,
  UsernameIcon,
} from './atom'
import { useTranslation } from 'react-i18next'
import { useGlobalStore } from '@/store/global/global-store'
import { isEn } from 'project-config/utils/env'
import { useEffect, useState } from 'react'
import { saleSmartlyInstance } from 'project-config/services'
import { getDomain } from 'project-config/utils/domain'
import { HeaderDropdown } from './components'
import { HumanService } from '@renderbus/widgets/components/human-service'
import { useHeader } from './hook/use-header'
import { UserInfoDropdown } from './components/user-info-dropdown'

export function Header() {
  const { userInfo, isDomestic, isPictureUser } = useGlobalStore()
  const { t } = useTranslation('common')
  const userName = userInfo && userInfo.userName ? userInfo.userName : ' '
  const [unRead, setUnRead] = useState(0)

  const { currentHover, handleHover, handleLeave } = useHeader()

  useEffect(() => {
    // 监听消息
    if (userInfo?.userId) {
      void saleSmartlyInstance.onUnRead(setUnRead)
    }
  }, [userInfo?.userId])

  return (
    <HeaderWrapper>
      <div className='left'>
        <>
          {getDomain() === 0 ? (
            <LogoWrap>
              <RenderbusLogo />
            </LogoWrap>
          ) : (
            <FoxLogo />
          )}
        </>
      </div>
      <div className='right'>
        <HeaderDropdown
          placement='bottomRight'
          showArrow
          dropdownRender={
            <HumanService
              salesmanEmail={userInfo?.salesmanEmail}
              salesmanName={userInfo?.salesmanName}
              salesmanPhone={userInfo?.salesmanPhone}
              isPictureUser={isPictureUser()}
              isDomestic={isDomestic()}
              unRead={unRead}
            />
          }
        >
          <HeaderItem
            width={isEn() ? '184px' : '110px'}
            align='flex-start'
            padding='0 0 0 10px'
            onMouseOver={() => handleHover('service')}
            onMouseOut={handleLeave}
            active={currentHover === 'service'}
          >
            <div className='message-icon'>
              {isDomestic() ? <ServiceActivedIcon /> : <ServiceFoxActivedIcon />}
              {!isDomestic() && unRead > 0 && <OrangeRadio />}
            </div>
            <span style={{ color: isDomestic() ? '#21DC9E' : '#FC7032' }}>
              {t('customer_service')}
            </span>
          </HeaderItem>
        </HeaderDropdown>
        <HeaderItemGapLine />
        <HeaderDropdown
          placement='bottomRight'
          popupWidth='max-content'
          showArrow
          arrowRight='16px'
          dropdownRender={<UserInfoDropdown />}
        >
          <HeaderItem
            maxContent
            align='flex-start'
            padding={`0 50px 0 16px`}
            onMouseOver={() => handleHover('user')}
            onMouseOut={handleLeave}
            active={currentHover === 'user'}
          >
            <UsernameIcon>
              <div>{userName[0].toUpperCase()}</div>
            </UsernameIcon>
            {userName}
          </HeaderItem>
        </HeaderDropdown>
      </div>
    </HeaderWrapper>
  )
}
